import { ConfigurationDeviceSectionAssayResponse } from '@/modules/configurationModule/detail/instrumentation/devices/services/configuration-device-section-assay/configuration-device-section-assay.dto'
import { AssayModalAssayWithValuableConceptResponse } from '@/components/assays-view/services/assays-view-assay/assays-view-assay.dto'
import { ConfigurationSectionResponse } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/configuration-section/configuration-section.dto'
import { Nullable } from '@/shared/types/app.types'
import { store } from '@/store/store'

export interface ConfigurationInstrumentationDevicesModalVisibilityFormSectionAssayState {
    assays: AssayModalAssayWithValuableConceptResponse[]
    assay: Nullable<AssayModalAssayWithValuableConceptResponse>
    sections: ConfigurationSectionResponse[]
    section: Nullable<ConfigurationSectionResponse>
    deviceSectionsAssays: ConfigurationDeviceSectionAssayResponse[]
    laboratoryId: number
}
export const initialConfigurationInstrumentationDevicesModalVisibilityFormSectionAssayState =
    (): ConfigurationInstrumentationDevicesModalVisibilityFormSectionAssayState => ({
        assays: [],
        assay: null,
        sections: [],
        section: null,
        deviceSectionsAssays: [],
        laboratoryId: store.getters.labId
    })
